//export const API_URL = 'https://dev-api-davide.plesh.co'
export const API_URL = 'https://dude-photo-api-2pcxz2m2qa-ew.a.run.app'
